import { useAuthorization } from 'components/Authorization';
import { hasSupervisePermission } from 'hooks/business/useRoles';

/**
 * 通过conversation.receptionId 及当前用户id 判断当前用户是否能直接与该conversation进行对话
 * conversation.receptionId 为0时代表当前没有任何人在接待该会话，任意客服均能接待
 * 如果是管理员，则可以直接认为可以任意进行对话
 * @param payloadduih
 * @param conversation
 * @returns
 */
export const calcTalkAvailable = (
  payload: Oversea.Token.Payload,
  conversation?: Conversation.Conversation,
) => {
  const isSuperviser = hasSupervisePermission(payload.roles);
  if (isSuperviser || !conversation) {
    // 管理员权限可以直接进行对话
    // 会话不存在时直接返回false
    return isSuperviser || false;
  }
  const { receptionId, controlStatus } = conversation;
  const userId = payload.id;
  const receptionIdStr = `${receptionId}`;
  const userIdStr = `${userId}`;
  return controlStatus || receptionIdStr === '0' || receptionIdStr === userIdStr;
};
export default function useTalkAvailable(conversation?: Conversation.Conversation) {
  const auth = useAuthorization<Oversea.Token.Payload>();
  if (!auth?.payload) {
    return false;
  }
  return calcTalkAvailable(auth!.payload, conversation);
}
